import { useEffect, useState } from "react";

import { dateToComparableNumber } from "@ryde/shared";

import { LIVE_MAP_POLL_PROGRESS_TICK_MS } from "./live-map.controls.constants";

export const useLiveMapPollCycleProgress = ({
  lastSyncIso,
  intervalMs,
  isPollingActive,
}: {
  lastSyncIso: TDateISO | undefined;
  intervalMs: number;
  isPollingActive: boolean;
}) => {
  const [elapsedPercent, setElapsedPercent] = useState(0);

  useEffect(() => {
    if (!isPollingActive || !lastSyncIso || intervalMs <= 0) {
      setElapsedPercent(0);
      return;
    }

    const update = (): void => {
      const lastMs = dateToComparableNumber(lastSyncIso);
      if (!lastMs) {
        setElapsedPercent(0);
        return;
      }

      const elapsed = Date.now() - lastMs;
      const elapsedPct = Math.max(
        0,
        Math.min(100, (elapsed / intervalMs) * 100),
      );
      setElapsedPercent(elapsedPct);
    };

    update();
    const id = window.setInterval(update, LIVE_MAP_POLL_PROGRESS_TICK_MS);
    return () => {
      window.clearInterval(id);
    };
  }, [intervalMs, isPollingActive, lastSyncIso]);

  return elapsedPercent;
};
